<div class="container app-content-body">
    <div class="row">
        <div class="col-10">
            <h5 class="text-uppercase font-weight-bold app-text-accent">{{'cancellation-and-return-policy.title' | translate}}</h5>
        </div>
        <div class="col-2">
            <div class="form-group">
                <select [(ngModel)]="language" name="selectedLanguage" id="selectedLanguage" class="p-dropdown" (change)="onChangeLanguage($event)">
                  <option [value]="item.id" *ngFor="let item of languages">{{item.text}}</option>
                </select>  
              </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>
                <strong>{{'cancellation-and-return-policy.information-requirements' | translate}}: </strong>
                {{'cancellation-and-return-policy.information-requirements-p1' | translate}}
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>
                <strong>{{'cancellation-and-return-policy.privacy-protection' | translate}}: </strong>
                {{'cancellation-and-return-policy.privacy-protection-p1' | translate}}
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>
                <strong>{{'cancellation-and-return-policy.credit-card-information-confirmation' | translate}}: </strong>
                {{'cancellation-and-return-policy.credit-card-information-confirmation-p1' | translate}}
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>
                <strong>{{'cancellation-and-return-policy.delivery-of-goods-and-services' | translate}}: </strong>
                {{'cancellation-and-return-policy.delivery-of-goods-and-services-p1' | translate}}
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>
                <strong>{{'cancellation-and-return-policy.transaction-terms-and-limitations' | translate}}: </strong>
                {{'cancellation-and-return-policy.transaction-terms-and-limitations-p1' | translate}}
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>
                <strong>{{'cancellation-and-return-policy.cancellation-and-refund' | translate}}: </strong>
                {{'cancellation-and-return-policy.cancellation-and-refund-p1' | translate}}
            </p>
        </div>
    </div>
</div>
